import { FC, useContext } from 'react';

import { useTopicState } from 'src/components/ResumeCard/Actions/Chatik/hooks/useTopicState';
import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import { VIEW_WITHOUT_CONTACTS } from 'src/utils/constants/resumePermission';

import MarkCardAsReadButton from 'src/components/ResumeCard/Actions/MarkCardAsReadButton';

const MarkCardAsReadButtonWrapper: FC<{ isMobile?: boolean; closeAdditionalMenu?: () => void }> = ({
    isMobile,
    closeAdditionalMenu,
}) => {
    const { isNew, markAsRead, resume, isPfpVacancy } = useContext(ResumeCardActionsContext);
    const isContactsHidden = isPfpVacancy ? false : resume._attributes.permission === VIEW_WITHOUT_CONTACTS;

    const topicState = useTopicState();
    const messagesCount = topicState?.conversationUnreadByEmployerCount || topicState?.conversationMessagesCount;

    if (isContactsHidden || !isNew || !markAsRead) {
        return null;
    }

    return (
        <MarkCardAsReadButton
            isMobile={isMobile}
            markAsRead={markAsRead}
            topicId={resume.topicId}
            messagesCount={messagesCount}
            closeAdditionalMenu={closeAdditionalMenu}
        />
    );
};

export default MarkCardAsReadButtonWrapper;
